import { useState } from "react";
import { useReportBrand } from "../reports/useReportBrand";
import { SettlementForm } from "./SettlementForm";
import { SettlementList } from "./SettlementList";

// تبويب التسويات: إنشاء مخالصة نهاية الخدمة لموظف منتهية خدمته + قائمة المحفوظة.
export const SettlementsTab = () => {
  const brand = useReportBrand();
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="grid gap-6" data-testid="settlements-tab">
      <SettlementForm brand={brand} onSaved={() => setRefreshKey((k) => k + 1)} />
      <SettlementList refreshKey={refreshKey} />
    </div>
  );
};
